<template>
  <div class="notice">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
<!--      <el-form-item label="厂家名称">-->
<!--        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="厂家编码">-->
<!--        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>-->
<!--      </el-form-item>-->
    </el-form>
    <div style="margin-bottom: 20px">
<!--      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon&#45;&#45;right"></i></el-button>-->
<!--      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon&#45;&#45;right"></i></el-button>-->
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题">
        </el-table-column>
        <el-table-column
            prop="content"
            :show-overflow-tooltip="true"
            label="内容">
        </el-table-column>
        <el-table-column
            prop="organization"
            label="发布机构名称">
        </el-table-column>
        <el-table-column
            prop="operatorAll"
            align="center"
            label="代理商全员查看">
          <template slot-scope="scope">
            <span>
              {{scope.row.operatorAll?'是':'否'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="pharmacyAll"
            align="center"
            label="药房全员查看">
          <template slot-scope="scope">
            <span>
              {{scope.row.pharmacyAll?'是':'否'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="publishDate"
            label="发布日期">
        </el-table-column>
        <el-table-column
            prop="expireDate"
            label="失效日期">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="deleteClick(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="65%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  class="demo-ruleForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="通知内容" prop="content">
          <Editor @content="content" :contents="ruleForm.content"></Editor>
        </el-form-item>
        <el-form-item label="代理商查看" >
          <el-switch
              v-model="ruleForm.operatorAll"
              active-color="#13ce66"
              inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="选择代理商" v-if="!ruleForm.operatorAll">
          <el-select
              v-model="ruleForm.operatorIds"
              multiple
              collapse-tags
              placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药房查看" >
          <el-switch
              v-model="ruleForm.pharmacyAll"
              active-color="#13ce66"
              inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
              v-model="ruleForm.publishDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效日期">
          <el-date-picker
              v-model="ruleForm.expireDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import Editor from "@/components/Editor";

export default {
  name: "notice",
  data() {
    return {
      tableData: [],
      searchForm: {},
      options: [],
      modelTitle: '新增通知',
      dialogVisible: false,
      ruleForm: {
        title:'',
        content:'',
        operatorAll:false,
        pharmacyAll:false,
        operatorIds:'',
        publishDate:null,
        expireDate:null,
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'},
        ],
        // content: [
        //   {required: true, message: '请输入通知内容', trigger: 'blur'},
        // ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    Editor
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {}
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    content(e){
      this.ruleForm.content=e
    },
    addItem() {
      this.modelTitle = '新增通知'
      this.ruleForm = {
        title:'',
        content:'',
        operatorAll:false,
        pharmacyAll:false,
        operatorIds:[],
        publishDate:null,
        expireDate:null,
      }
      this.dialogVisible = true
    },
    editorClick(row) {
      this.modelTitle = '编辑通知'
      this.areaId = row.id
      this.ruleForm = {
       ...row,
        operatorIds:row.operatorIds
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            operatorIds:this.ruleForm.operatorIds.map(String)
          }
          if (this.modelTitle === '编辑通知') {
            this.axios
                .put("/api/Notice?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          } else {
            this.axios
                .post("/api/Notice", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    deleteClick(flag) {
        let data = {
          id: flag.id
        }
        this.axios
            .delete("/api/Notice", {params:data}).then((res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }).finally(error=>{
          this.init()
        })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },

    // list
    init() {
      let data = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("/api/Notice/GetMy", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.tableData.forEach(item=>{
              item.publishDate = this.dayjs(item.publishDate).format('YYYY/MM/DD')|| ' '
              item.expireDate = this.dayjs(item.expireDate).format('YYYY/MM/DD')|| ' '
              item.createTime = this.dayjs(item.createTime).format('YYYY/MM/DD HH:mm')|| ' '
            })
            this.total = res.count
          })
    },
    DIC(){
      this.axios
          .get('/api/Dic',{params: {dicType:6}})
          .then((res) => {
            this.options=res
            this.options.forEach(item=>{
              item.label=item.name
              item.value=item.id
            })
          })
    },
  },
  mounted() {
    //
    this.init()
    this.DIC()
  }
}
</script>

<style lang="scss" scoped>
.notice {

}
</style>